// extracted by mini-css-extract-plugin
var _1 = "RNkKOJ69nnhucu2mKZW2";
export { _1 as "root" }
